import { cn } from '@/utils';
import { Stepper, type Step } from '@/components/common';

interface WizardContainerProps {
  title: string;
  description?: string;
  steps: Step[];
  currentStep: number;
  onStepClick?: (step: number) => void;
  children: React.ReactNode;
  className?: string;
}

export function WizardContainer({
  title,
  description,
  steps,
  currentStep,
  onStepClick,
  children,
  className,
}: WizardContainerProps) {
  return (
    <div className={cn('max-w-4xl mx-auto', className)}>
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
        {description && (
          <p className="mt-1 text-gray-500 dark:text-gray-400">{description}</p>
        )}
      </div>

      {/* Stepper */}
      <div className="mb-8">
        <Stepper steps={steps} currentStep={currentStep} onStepClick={onStepClick} />
      </div>

      {/* Content */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 sm:p-8">
        {children}
      </div>
    </div>
  );
}
